import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CardStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardSectionContainer: {
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      height: "100%",
      marginBottom: "30px",
      flexWrap: "nowrap",
    },
    innerContainer: {
      marginRight: "23px",
    },
    container: {
      backgroundColor: theme.palette.background.default,
      borderRadius: "12px",
      height: "auto",
      minHeight: "300px",
      maxHeight: "300px",
      width: "380px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      padding: "30px",
      margin: "15px 0px",
    },
    topContainer: {
      marginBottom: "10px",
    },
    middleContainer: {
      marginBottom: "20px",
    },
    title: {
      color: theme.palette.text.primary,
      fontSize: "20px",
      fontWeight: 700,
    },
    link: {
      color: theme.palette.text.secondary,
      fontSize: "16px",
      textDecorationColor: theme.palette.text.secondary,
      cursor: "pointer",
    },
    listContainer: {
      width: "320px",
      padding: "0px",
      minHeight: "146px",
    },
    listItem: {
      padding: "5px 0px",
      cursor: "pointer",
    },
    listItemRank: {
      maxWidth: "fit-content",
      marginRight: "15px",
    },
    listItemIcon: {
      minWidth: "fit-content",
      marginRight: "10px",
      maxHeight: "30px",
    },
    listName: {
      fontSize: "16px",
    },
  }),
);
